// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__wI6fM","inner":"Footer_inner__1Z6qC","nextIcon":"Footer_nextIcon__hqsTs","innerLeft":"Footer_innerLeft__2KgGz"};